import { useMemo } from 'react';
import { ExtendedPosition } from 'api/model';
import { getDistanceInKm } from 'utils/speed';
import { FixedPosition } from './types';

const useFixedPositionsEnterAndExistData = (
  fixedPositions: FixedPosition[] | undefined,
  positions: ExtendedPosition[]
) => {
  const result = useMemo(() => {
    // finds the first and last position for each fixed position and returns a new array including the enterAndExitData, where enter = arrived within 500m of the fixed position, and exit = left within 500m of the fixed position
    if (!fixedPositions || fixedPositions.length === 0) return [];
    return fixedPositions.map((fixedPosition) => {
      const enterAndExitData = fixedPosition.assignmentIds.map(
        (assignmentId) => {
          const positionsForAssignment = positions.filter(
            (p) => p.assignmentId === assignmentId
          );
          if (positionsForAssignment.length === 0) {
            return { assignmentId };
          }

          const firstPositionWithin500m = positionsForAssignment.find(
            (p) =>
              getDistanceInKm(
                {
                  latitude: p.latitude,
                  longitude: p.longitude,
                },
                {
                  latitude: fixedPosition.latitude,
                  longitude: fixedPosition.longitude,
                }
              ) <= 0.5
          );
          const lastPositionWithin500m = [...positionsForAssignment]
            .reverse()
            .find(
              (p) =>
                getDistanceInKm(
                  {
                    latitude: p.latitude,
                    longitude: p.longitude,
                  },
                  {
                    latitude: fixedPosition.latitude,
                    longitude: fixedPosition.longitude,
                  }
                ) <= 0.5
            );
          if (!firstPositionWithin500m || !lastPositionWithin500m) {
            return { assignmentId };
          }

          return {
            assignmentId,
            enterTimestamp: firstPositionWithin500m.timestamp,
            exitTimestamp: lastPositionWithin500m.timestamp,
          };
        }
      );

      return {
        ...fixedPosition,
        enterAndExitData,
      };
    });
  }, [fixedPositions, positions]);

  return result;
};

export default useFixedPositionsEnterAndExistData;
